/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["columns", "columnLeft", "columnRight"];

  initialize() {
    this.range = 100;
    this.columnLeftStartAt = -125;
    this.columnRightStartAt = -50;
  }

  connect() {
    this.updatePositions();
    window.addEventListener("scroll", this.updatePositions.bind(this));
  }

  updatePositions() {
    const { top: topDistance, height } = this.columnsTarget.getBoundingClientRect();
    const bottomDistance = topDistance + height;

    if (topDistance < 0 && bottomDistance > 0) {
      const magicNumber = parseFloat(((Math.abs(topDistance) * this.range) / height).toFixed(2));
      const { left, right } = this.getNewPositions(magicNumber);

      this.columnLeftTarget.style.transform = `translate3d(0, ${left}px, 0)`;
      this.columnRightTarget.style.transform = `translate3d(0, ${right}px, 0)`;
    }
  }

  getNewPositions(magicNumber) {
    return {
      left: this.columnLeftStartAt + magicNumber,
      right: this.columnRightStartAt - magicNumber,
    }
  }
}
